import React, { useEffect } from 'react';
import Box from 'core/ui/Box';
import { useTranslation } from 'react-i18next';
import SelectBoxObject from 'core/ui/SelectBoxObject';
import { channelsSelectors } from 'modules/channels';
import { useSelector } from 'react-redux';

const FormMembershipCancelRequest = ({ values, onChangeFormValues }) => {
  const { t } = useTranslation();
  const channel = useSelector((state) => channelsSelectors.getChannel(state));

  useEffect(() => {
    if (!values?.filterType) {
      onChangeFormValues({ filterType: 'both' });
    }
  }, []);

  return (
    <Box className="gap-10" display="flex" flexDirection="column" mt={2}>
      <Box>
        <SelectBoxObject
          emptyItem
          emptyValue={null}
          label={t('label.membershipPlan').toUpperCase()}
          placeholder={t('label.allMembershipsPlans')}
          options={channel?.membershipPlans}
          value={values?.membershipPlanId}
          setValue={(v) => onChangeFormValues({ membershipPlanId: v })}
          bordered
        />
      </Box>
    </Box>
  );
};

export default FormMembershipCancelRequest;
